import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { PercentLoaderIcon } from '../../assets/icons/PercentLoaderIcon'
import { getMergedClassNames } from '../../utils/HTMLutils'
import IconButton from '../iconButton/IconButton'
import './TableFileNameAndAction.scss'
const rootClassName = 'component-table-file-name-and-action'

function TableFileNameAndAction(props) {
  return (
    <div className={rootClassName}>
      {props.files && props.files.length
        ? props.files.map((line, index) => {
            const obj = line.file ? line.file : line
            return (
              <div
                key={index}
                className={getMergedClassNames([
                  `${rootClassName}-file`,
                  line.disabled ? 'disabled' : '',
                  line.error ? 'error' : ''
                ])}
              >
                <span>{obj.name}</span>
                <IconButton
                  icon={
                    line.uploading ? (
                      <PercentLoaderIcon
                        indefinido={line.indefinido}
                        value={String(line.progress)}
                      />
                    ) : (
                      props.rightIcon
                    )
                  }
                  disabled={props.disabledRightIcon || line.disabled || false}
                  onClick={() => {
                    if (typeof props.onRightIconClick === 'function') {
                      props.onRightIconClick(index)
                    }
                  }}
                />
              </div>
            )
          })
        : undefined}
    </div>
  )
}

TableFileNameAndAction.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.object,
      progress: PropTypes.number,
      indefinido: PropTypes.bool,
      uploading: PropTypes.bool,
      error: PropTypes.bool
    })
  ),
  rightIcon: PropTypes.object,
  onRightIconClick: PropTypes.func,
  disabledRightIcon: PropTypes.bool
}

TableFileNameAndAction.defaultProps = {}

export default memo(TableFileNameAndAction)
